import React from 'react';
import styled from 'styled-components';
import SearchOutlined from '@ant-design/icons/SearchOutlined';
import { Button, Input, DatePicker } from 'antd';
import { decodeDateRange, encodeDateRange } from './tableExtensionsUtils';
const { RangePicker } = DatePicker;
export const BasicFilterDropdown = ({ setSelectedKeys, selectedKeys, confirm, clearFilters, }) => (React.createElement(DropWrap, null,
    React.createElement(DropDown, null,
        React.createElement(InputArea, { placeholder: "Search", value: selectedKeys[0], onChange: (e) => setSelectedKeys(e.target.value ? [e.target.value] : []), onPressEnter: confirm }),
        React.createElement(Button, { type: "primary", onClick: () => confirm({ closeDropdown: true }), icon: React.createElement(SearchOutlined, null) }, "Search"),
        React.createElement(Button, { onClick: clearFilters }, "Reset"))));
export const DateFilterDropdown = ({ setSelectedKeys, selectedKeys, confirm, clearFilters, dateFormat, }) => {
    return (React.createElement(DropWrap, null,
        React.createElement(DropDown, null,
            React.createElement(RangePickerArea, { value: selectedKeys[0] ? decodeDateRange(selectedKeys[0]) : undefined, allowEmpty: [true, true], onChange: (_dates, dateStrings) => {
                    // there seems to be a Table bug where it doesn't truly accept multiple values in a way that allows for filtering.
                    // To get around it, we'll just put all the data in one string and deal with parsing.
                    setSelectedKeys([
                        encodeDateRange(dateFormat, dateStrings[0], dateStrings[1]),
                    ]);
                } }),
            React.createElement(Button, { type: "primary", onClick: () => confirm({ closeDropdown: true }), icon: React.createElement(SearchOutlined, null) }, "Search"),
            React.createElement(Button, { onClick: clearFilters }, "Reset"))));
};
// re-exporting here to keep it in the same area as the other table-date related functions
export * from './tableExtensionsUtils';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const SearchIcon = styled(({ filtered, ...rest }) => React.createElement(SearchOutlined, { ...rest })) `
    &&& {
        color: ${({ theme, filtered }) => filtered
    ? theme.palette.secondary.default.toString()
    : theme.palette.primary.default.toString()};
    }
`;
const DropWrap = styled.div `
    width: 300px;
`;
const DropDown = styled.div `
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding: ${({ theme }) => theme.spacing.sm.toString()};
    gap: ${({ theme }) => theme.spacing.sm.toString()};
`;
const InputArea = styled(Input) `
    grid-column: 1 / span 2;
`;
const RangePickerArea = styled(RangePicker) `
    grid-column: 1 / span 2;
`;
export const FilterIcon = (filtered) => (React.createElement(SearchIcon, { filtered: filtered, alt: "Filter Column" }));
//# sourceMappingURL=tableExtensions.js.map